// extracted by mini-css-extract-plugin
module.exports = {"root":"_2ntRE0","facebook":"_2IRV0b","disabled":"_1DtC_b","google":"_1Qn3Kh"};